export const FRONTEND_URL: string | undefined = process.env.REACT_APP_FRONTEND_URL
export const SPACES_PORT: string | undefined = process.env.REACT_APP_SPACES_PORT;
export const AUTH_SERVICE: string | undefined = process.env.REACT_APP_AUTH_URL
export const SUPPORT_URL: string | undefined = "https://" + process.env.REACT_APP_SUPPORT_URL
export const REALM: string | undefined = process.env.REACT_APP_REALM
export const CLIENT_ID: string | undefined = process.env.REACT_APP_KEYCLOAK_CLIENT

export const applicationName: string = "Yacht.Chat"

export const INSTA = "https://instagram.com/yacht.chat/"
export const LINKEDIN = "https://www.linkedin.com/company/yacht-chat/"
export const TIKTOK = "https://tiktok.com"
export const GITHUB = "https://github.com/YachtChat/YachtChat"
export const EMAIL = "mailto:contact@yacht.chat"